// Random.js

//===================================
//
// Replaceable for "randomness".
// ES6.
//
// Lou Mauget, Keyhole Sefotware
// November 6, 2015
//
//===================================

class Random {

	// Returns a random integer between min (included) and max (excluded)
	// Using Math.round() will give you a non-uniform distribution!
	static getRandomInt(min, max) {
	  return Math.floor(Math.random() * (max - min)) + min;
	}

}

export default Random;
